import React from 'react';

import { Button, List, ListItem, Typography, ButtonIcon } from '@hpi-sox/hpstellar-core/visId';
import { ChevronUp, ChevronDown, X } from '@hpi-sox/hpstellar-vis-icons';

import { getOffersModals } from '../../../../get-product-props';
import { useGetProductPrice } from '../../../../../hooks/useProductPrice';
import { useOffersView } from '../../../../../hooks/useProductCompare';
import { Helpers } from '../../../../../core/src/helpers';

import './offers.less';

const OffersModal = ({ product, contentProps, onClose, ctaText = 'Hide all promo offers', title = 'All Offers' }) => {
    const { list, miniProductTileProps } = contentProps || {};
    const { image, description, name } = miniProductTileProps || {};
    return (
        <div className="product-offers-container">
            <div>
                <div className="offers-header">
                    <Typography variant="h4">{title}</Typography>
                    <ButtonIcon className="offers-close" onClick={onClose} icon={<X size="s" />} size="small" />
                </div>
                {miniProductTileProps && (
                    <div className="offers-product-details">
                        {image && (
                            <div className="offers-product-image">
                                <img src={image.url} alt={image.alt} />
                            </div>
                        )}
                        <div>
                            <Typography className="offers-product-name" variant="caption">
                                {name}
                            </Typography>
                            <Typography
                                className="offers-product-specs"
                                variant="footnotes"
                                dangerouslySetInnerHTML={Helpers.createMarkup(description)}
                            />
                        </div>
                    </div>
                )}
                <List className="product-offers-list">
                    {list.map((li, idx) => (
                        <ListItem key={idx}>{li}</ListItem>
                    ))}
                </List>
            </div>
            <div className="toggle-offers">
                <Button theme="dark" variation="tertiary" onClick={onClose}>
                    {ctaText}
                </Button>
                <ChevronUp size="s" />
            </div>
        </div>
    );
};

export default ({ product, ctaText = 'See all promo offers' }) => {
    const priceObj = useGetProductPrice(product, { useProductPromos: true });
    const offersState = useOffersView(product);
    const { modalProps: offerModal } = getOffersModals(product, offersState, priceObj, undefined, ' | ') || {};
    const className = "toggle-offers";
    if (!offerModal) {
        return <div className={className} />;
    }
    const { onToggle, isOpen, contentProps } = offerModal;
    return (
        <>
            {isOpen && <OffersModal product={product} contentProps={contentProps} onClose={() => onToggle(false)} />}
            <div className={className}>
                <Button theme="dark" variation="tertiary" onClick={() => onToggle(!isOpen)}>
                    {ctaText}
                </Button>
                <ChevronDown size="s" />
            </div>
        </>
    );
};
